jQuery(document).ready(function($) {
   jQuery('.icontext_slider__wrapper').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: true, // Enable auto-play
        autoplaySpeed: 1000, // Set the speed of auto-play (in milliseconds)
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
//
jQuery(document).ready(function($) {
    jQuery('.image_slider__wrapper').slick({
        dots: false,
       arrow: true,

        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false, // Enable auto-play
        autoplaySpeed: 1000, // Set the speed of auto-play (in milliseconds)
       
    });
});
//////////
function filterSelection(category) {
    var items = document.getElementsByClassName('item');
    var totalItems = items.length;
    var visibleCount = 0;

    // Show all items if "all" is selected
    if (category === 'all') {
        for (var i = 0; i < items.length; i++) {
            items[i].style.display = 'block';
            visibleCount++;
        }
    } else {
        for (var i = 0; i < items.length; i++) {
            if (items[i].classList.contains(category)) {
                items[i].style.display = 'block';
                visibleCount++;
            } else {
                items[i].style.display = 'none';
            }
        }
    }

    // Update the progress bar
    // var progress = document.getElementById('progress');
    // var width = (visibleCount / totalItems) * 100;
    // progress.style.width = width + '%';
}

// Call filterSelection with 'heels' when the page loads
window.onload = function() {
    filterSelection('sandals');
};

///btn active

// jQuery script
$(document).ready(function() {
  $(".tab-button").click(function() {
    $(".tab-button").removeClass("active"); // Remove 'active' class from all buttons
    $(this).addClass("active"); // Add 'active' class to the clicked button
  });
});


//////

jQuery(document).ready(function($) {
   jQuery('.collectionproduct-slider-wrapper').slick({
        dots: false,
         arrow: false,
        infinite: true,
        speed: 1000,
        slidesToShow:4,
        slidesToScroll: 1,
        autoplay: true, // Enable auto-play
        autoplaySpeed: 1000, // Set the speed of auto-play (in milliseconds)
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll:1,
                    dots: false,
                     arrow: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});